import { Component, input } from '@angular/core';

@Component({
  selector: 'portal-erfolg-4-svg',
  standalone: true,
  templateUrl: './erfolg-4.component.svg',
  styleUrl: './erfolg-4.component.scss',
})
export class Erfolg4SvgComponent {
  public showCheckMark = input<boolean>(false);
}
